export default __webpack_public_path__ + "static/media/bgAccountAccordion.056a3c76.png";